import Slideshow from '../../../components/slideshow/Slideshow';
import { GALLERY } from '../../../utils/constants';

const Gallery = ({ imageList }: { imageList: string[] }) => {
  return (
    <div id={GALLERY} className='gallery'>
      <div className='gallery_container container'>
        <h2 data-aos='fade-up'>GALLERY</h2>
        <div
          data-aos='fade-up'
          data-aos-delay='50'
          className='gallery_container_imgs'
        >
          <Slideshow slideshowImages={imageList} />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
